import { createReducer, createAction, PayloadAction } from '@reduxjs/toolkit'

export interface Client {
  id: string
  name: string
  email: string
  phone_number: string
  client_type: 'personal' | 'company' | null
  country: string | null
  tax_number?: string
  street?: string
  house_number?: string
  zip_code?: string
  place?: string
}

export interface ClientsReducer {
  clients: Client[]
  totalPages: number
  currentPage: number
  totalCount: number
  searchTerm: string
  loading: boolean
}

const initialState: ClientsReducer = {
  clients: [],
  totalPages: 0,
  currentPage: 1,
  totalCount: 0,
  searchTerm: '',
  loading: false
}

interface UpdateClientPayload {
  id: string
  name: string
  email: string
}

export type UpdateClientActionType = PayloadAction<UpdateClientPayload>

export const UPDATE_CLIENT = createAction<UpdateClientPayload>('clients_reducer/update_client')
export const UPDATE_CLIENT_SUCCESS = createAction<UpdateClientPayload>('clients_reducer/update_client_success')
export const UPDATE_CLIENT_FAILURE = createAction('clients_reducer/update_client_failure')

export const DELETE_CLIENT = createAction<string>('clients_reducer/delete_client')
export const DELETE_CLIENT_SUCCESS = createAction<string>('clients_reducer/delete_client_success')
export const DELETE_CLIENT_FAILURE = createAction('clients_reducer/delete_client_failure')

interface FetchClientsSuccessPayload {
  clients: Client[]
  totalPages: number
  totalCount: number
}

export const FETCH_CLIENTS = createAction('clients_reducer/fetch_clients')
export const FETCH_CLIENTS_SUCCESS = createAction<FetchClientsSuccessPayload>('clients_reducer/fetch_clients_success')
export const FETCH_CLIENTS_FAILURE = createAction('clients_reducer/fetch_clients_failure')
export const SET_CURRENT_PAGE = createAction<number>('clients_reducer/set_current_page')
export const SET_SEARCH_TERM = createAction<string>('clients_reducer/set_search_term')

export const clientsReducer = createReducer(initialState, (builder) => {
  builder.addCase(UPDATE_CLIENT, (state, action) => {
    return { ...state }
  })
  builder.addCase(UPDATE_CLIENT_SUCCESS, (state, action) => {
    return {
      ...state,
      clients: state.clients.map((client) => {
        if (client.id === action.payload.id) {
          return { ...client, name: action.payload.name, email: action.payload.email }
        }
        return client
      })
    }
  })
  builder.addCase(DELETE_CLIENT, (state, action) => {
    return { ...state }
  })
  builder.addCase(DELETE_CLIENT_SUCCESS, (state, action) => {
    return {
      ...state,
      clients: state.clients.filter((client) => client.id !== action.payload)
    }
  })
  builder.addCase(FETCH_CLIENTS, (state) => {
    return { ...state, loading: true }
  })
  builder.addCase(FETCH_CLIENTS_SUCCESS, (state, action) => {
    return {
      ...state,
      clients: action.payload.clients,
      totalPages: action.payload.totalPages,
      totalCount: action.payload.totalCount,
      loading: false
    }
  })
  builder.addCase(FETCH_CLIENTS_FAILURE, (state) => {
    return { ...state, clients: [], loading: false }
  })
  builder.addCase(SET_CURRENT_PAGE, (state, action) => {
    return { ...state, currentPage: action.payload }
  })
  builder.addCase(SET_SEARCH_TERM, (state, action) => {
    return { ...state, searchTerm: action.payload }
  })
})
